<p-table
  [tableStyle]="{ 'min-width': '20rem' }"
  #tableRef
  [value]="_tableData()"
  [columns]="_columns()"
  [globalFilterFields]="globalFilterFields()"
  [filters]="filters()"
  (onFilter)="onFilterLocal($event)">
  <ng-template pTemplate="caption">
    <div class="flex justify-content-between align-items-center">
      <h5 class="m-0">Table Data</h5>
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input pInputText type="text" (input)="onGlobalFilter($event)" placeholder="Search keyword" />
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      @for (column of columns; track column) {
      <th [pSortableColumn]="column.field">{{ column.header }} <p-sortIcon [field]="column.field"></p-sortIcon></th>
      }
    </tr>
    <tr>
      @for (column of columns; track column) { @if(column.type === 'tags') {
      <th>
        <p-multiselect
          [options]="filters()?.[column.field]?.['options']"
          placeholder="Selecciona"
          (onChange)="filterOutsideTable('tags', column.field, $event.value)"
          [style]="{ minWidth: '14rem' }"
          [panelStyle]="{ minWidth: '16rem' }">
          <ng-template let-option #item>
            <div class="flex items-center gap-2">
              <span>{{ option }}</span>
            </div>
          </ng-template>
        </p-multiselect>
      </th>

      } @else {
      <th>
        <p-columnFilter [type]="getFilterType(column)" [field]="column.field" placeholder="Search" [showMenu]="false"></p-columnFilter>
      </th>
      } }
    </tr>
  </ng-template>
  <!-- @if(tableData()){ -->
  <ng-template pTemplate="body" let-item let-columns="columns">
    <tr>
      @for (column of columns; track column) {
      <td>
        @if(column.type === 'image'){
        <div class="image-container">
          <img [src]="item | getPath: column" alt="Image" class="image" />
        </div>
        } @else if(column.type === 'tags') {
        <div class="tags-container">
          @for (tag of item[column.field]; track tag) {
          <p-tag [rounded]="true" [value]="tag"></p-tag>
          }
        </div>
        } @else if(column.type === 'actions') {
        <div style="display: flex; gap: 2px">
          @for (actionBtn of _actions(); track actionBtn) {
          <p-button (click)="selectItem(item, actionBtn)" [icon]="actionBtn.icon" [severity]="actionBtn['severity']" />
          }
        </div>
        } @else {
        <span>{{ item | getPath: column}} </span>
        }
      </td>
      }
    </tr>
  </ng-template>
  <!-- } -->
</p-table>
